import configuracao from './configuracao'
import gestor from './gestor'
import notificacao from './notificacao'
import papel from './papel'
import permissao from './permissao'
import relatorioAcessoFuncionalidade from './relatorioAcessoFuncionalidade'
import relatorioAcessoSistema from './relatorioAcessoSistema'
import relatorioHistoricoPapelLotacao from './relatorioHistoricoPapelLotacao'
import relatorioHistoricoPermissaoLotacao from './relatorioHistoricoPermissaoLotacao'
import relatorioHistoricoPermissaoPapel from './relatorioHistoricoPermissaoPapel'
import relatorioPapelLotacao from './relatorioPapelLotacao'
import relatorioPermissaoLotacao from './relatorioPermissaoLotacao'
import relatorioPermissaoPapel from './relatorioPermissaoPapel'

export default [
    {
        path: 'administracao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...configuracao,
            ...gestor,
            ...notificacao,
            ...papel,
            ...permissao,
            ...relatorioAcessoFuncionalidade,
            ...relatorioAcessoSistema,
            ...relatorioHistoricoPapelLotacao,
            ...relatorioHistoricoPermissaoLotacao,
            ...relatorioHistoricoPermissaoPapel,
            ...relatorioPapelLotacao,
            ...relatorioPermissaoLotacao,
            ...relatorioPermissaoPapel,
        ]
    }
]